import { parse, format } from 'url';

import { BureauSDK } from './bureau';
export const loadBureauSdk = async (): Promise<BureauSDK> => {
    return new Promise<BureauSDK>(resolve => {
        if (!!window.DeviceIntelligence && !!window.DeviceIntelligence.init) {
            resolve(window.DeviceIntelligence);
            return;
        }

        const urlObject = parse('https://di.prd.bureau.id/v1.3.3/bureau-device-intelligence.js', true);
        urlObject.query.render = 'explicit';
        urlObject.search = '';

        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = format(urlObject);
        script.defer = true;
        script.id = 'bureau-jssdk';
        document.body.appendChild(script);

        const waitingBureauReady = setInterval(() => {
            if (!!window.DeviceIntelligence && !!window.DeviceIntelligence.init) {
                resolve(window.DeviceIntelligence);
                window.clearInterval(waitingBureauReady);
            }
        }, 300);
    });
};
